module.exports = __webpack_public_path__ + "img/Essex Finney with Mr. and Mrs. Hoge, 1959 .d688292d.jpg";